import React, {useState, useEffect} from 'react';
import './Header.css';
import {useNavigate} from "react-router-dom";
import {auth} from "../../firebase";
import {signOut} from "firebase/auth";

const Header = () => {
    const navigate = useNavigate();
    const user = auth.currentUser;
    const [menuOpen, setMenuOpen] = useState(false);

    // Close the mobile menu when the viewport grows back to desktop width.
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768 && menuOpen) {
                setMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [menuOpen]);

    // Lock body scroll while the slide-out menu is open on mobile.
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [menuOpen]);

    const handleAuthAction = () => {
        setMenuOpen(false);
        if (user) {
            signOut(auth).then(() => {
                navigate('/map');
            }).catch((error) => {
                console.error('Sign out error:', error);
            });
        } else {
            navigate('/login');
        }
    };

    const closeMenu = () => setMenuOpen(false);

    return (<header className="blue-header">
        {/* Logo on the left */}
        <div className="header-logo">
            <a href="/">
                <img
                    src="/images/ΕΣΑΕ_LOGO.png"
                    alt="Rare Diseases Greece Logo"
                    className="logo"
                />
            </a>
        </div>

        {/* Hamburger toggle — only visible on mobile via CSS */}
        <button
            className={`hamburger ${menuOpen ? 'is-open' : ''}`}
            aria-label={menuOpen ? 'Κλείσιμο μενού' : 'Άνοιγμα μενού'}
            aria-expanded={menuOpen}
            aria-controls="primary-navigation"
            onClick={() => setMenuOpen(o => !o)}
        >
            <span></span>
            <span></span>
            <span></span>
        </button>

        {/* Backdrop to close menu on mobile when tapping outside */}
        {menuOpen && <div className="nav-backdrop" onClick={closeMenu} aria-hidden="true"/>}

        {/* Tabs (menu items) */}
        <nav id="primary-navigation" className={`navbar ${menuOpen ? 'is-open' : ''}`}>
            <a href="/rare-diseases" onClick={closeMenu}>Σπάνιες Παθήσεις</a>
            <a href="/about-map" onClick={closeMenu}>Ο Χάρτης</a>
            <a href="/about-us" onClick={closeMenu}>Ε.Σ.Α.Ε.</a>
            <a href="/information" onClick={closeMenu}>Πληροφορίες</a>
            <a href="/faq" onClick={closeMenu}>Συχνές Ερωτήσεις</a>
            <button className="auth-button" onClick={handleAuthAction}>
                {user ? 'Αποσύνδεση' : 'Σύνδεση'}
            </button>
        </nav>
    </header>);
};

export default Header;
